
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cw20WbAnJO3eGhMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/index/cw20.vue?macro=true";
import { default as indexovxV1n9k7eMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/index/index.vue?macro=true";
import { default as indexBoJJ2YG4AdMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/index.vue?macro=true";
import { default as indexR7RhPgJYLdMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/nft/index.vue?macro=true";
import { default as indexS7Z9b3ZKVMMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking/index.vue?macro=true";
import { default as restakeF6QgfQFww6Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking/restake.vue?macro=true";
import { default as unstakeYvtn04JBNfMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking/unstake.vue?macro=true";
import { default as stakingsfJppD5uKkMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking.vue?macro=true";
import { default as transactionsPUV0vpDSP3Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/transactions.vue?macro=true";
import { default as _91account_93CWcUxplHZTMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account].vue?macro=true";
import { default as _91denom_936Uhuy0EWdnMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/asset/[denom].vue?macro=true";
import { default as indexGbdzaB98JxMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/assets/index.vue?macro=true";
import { default as smart_45contracts8JCxmRMK5IMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/assets/smart-contracts.vue?macro=true";
import { default as assetsrB0EYYdKTsMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/assets.vue?macro=true";
import { default as _91block_93JlOK0ZFVqbMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/block/[block].vue?macro=true";
import { default as blocksqXMIdZVbT1Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/blocks.vue?macro=true";
import { default as _91code_93KfLFZx1VqcMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/code/[code].vue?macro=true";
import { default as community_45spend_45poolxFkehCOrWrMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/community-spend-pool.vue?macro=true";
import { default as executehKas4aSrcAMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/action/execute.vue?macro=true";
import { default as indexR152qIlBaAMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/action/index.vue?macro=true";
import { default as action8p3hpi3kLTMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/action.vue?macro=true";
import { default as balancesHsnz4qnVb7Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/balances.vue?macro=true";
import { default as cw20balancesSP3mEizxzbMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/cw20balances.vue?macro=true";
import { default as indexKjlvZ6x6v1Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/index.vue?macro=true";
import { default as inityAYvKz35LUMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/init.vue?macro=true";
import { default as token_45holdersc5vNKI8DLsMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/token-holders.vue?macro=true";
import { default as _91contract_93QnARDyTDbDMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract].vue?macro=true";
import { default as envXWlt2BHjPAMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/env.vue?macro=true";
import { default as indexwpmggW8eXuMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/index.vue?macro=true";
import { default as localesY1cdtKHyrdMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/locales.vue?macro=true";
import { default as maintenance3AsTYwf8qYMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/maintenance.vue?macro=true";
import { default as _91market_9352uBn8gJB6Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/market/[market].vue?macro=true";
import { default as funding_45rate_45historyjUUnodAjCOMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/markets/funding-rate-history.vue?macro=true";
import { default as indexJFjlLdGtC1Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/markets/index.vue?macro=true";
import { default as realtime_45funding_45rateuh9y0amMGNMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/markets/realtime-funding-rate.vue?macro=true";
import { default as trading_45rulesQUNll6LV9gMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/markets/trading-rules.vue?macro=true";
import { default as marketsfdWpEczQOtMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/markets.vue?macro=true";
import { default as indexVhE1po0zvAMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/nft/[id]/index.vue?macro=true";
import { default as not_45foundyzoaSbMerBMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/not-found.vue?macro=true";
import { default as playgroundy9JZBBfKERMeta } from "/home/runner/_work/injective-explorer/injective-explorer/node_modules/.c12/github_InjectiveLabs_injective_1IfPyDVKuA/pages/playground.vue?macro=true";
import { default as raw_45txY3YPiYb0tBMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/raw-tx.vue?macro=true";
import { default as codejBV0zTiVUoMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/smart-contracts/code.vue?macro=true";
import { default as indexhrhB3WyVd1Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/smart-contracts/index.vue?macro=true";
import { default as smart_45contractsQ9KbCjESLFMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/smart-contracts.vue?macro=true";
import { default as _91tradeId_93eTrMKkzo6RMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/derivatives/[tradeId].vue?macro=true";
import { default as indexInLo418pFcMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/derivatives/index.vue?macro=true";
import { default as index87R2EnwfY6Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/index.vue?macro=true";
import { default as _91tradeId_93CnKVgmEmcbMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/spot/[tradeId].vue?macro=true";
import { default as indexe2zHjxS2WdMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/spot/index.vue?macro=true";
import { default as trade_45historyFE4qcg5gAvMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history.vue?macro=true";
import { default as event_45logsc9sksHU8JpMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/transaction/[transaction]/event-logs.vue?macro=true";
import { default as index4WMA9wI262Meta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/transaction/[transaction]/index.vue?macro=true";
import { default as _91transaction_93Fudkvyr5NAMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/transaction/[transaction].vue?macro=true";
import { default as transactionsRrWFvFLQlQMeta } from "/home/runner/_work/injective-explorer/injective-explorer/pages/transactions.vue?macro=true";
export default [
  {
    name: _91account_93CWcUxplHZTMeta?.name,
    path: "/account/:account()",
    meta: _91account_93CWcUxplHZTMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account].vue"),
    children: [
  {
    name: indexBoJJ2YG4AdMeta?.name,
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/index.vue"),
    children: [
  {
    name: "account-account-index-cw20",
    path: "cw20",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/index/cw20.vue")
  },
  {
    name: "account-account-index",
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/index/index.vue")
  }
]
  },
  {
    name: "account-account-nft",
    path: "nft",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/nft/index.vue")
  },
  {
    name: stakingsfJppD5uKkMeta?.name,
    path: "staking",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking.vue"),
    children: [
  {
    name: "account-account-staking",
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking/index.vue")
  },
  {
    name: "account-account-staking-restake",
    path: "restake",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking/restake.vue")
  },
  {
    name: "account-account-staking-unstake",
    path: "unstake",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/staking/unstake.vue")
  }
]
  },
  {
    name: "account-account-transactions",
    path: "transactions",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/account/[account]/transactions.vue")
  }
]
  },
  {
    name: "asset-denom",
    path: "/asset/:denom()",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/asset/[denom].vue")
  },
  {
    name: assetsrB0EYYdKTsMeta?.name,
    path: "/assets",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/assets.vue"),
    children: [
  {
    name: "assets",
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/assets/index.vue")
  },
  {
    name: "assets-smart-contracts",
    path: "smart-contracts",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/assets/smart-contracts.vue")
  }
]
  },
  {
    name: "block-block",
    path: "/block/:block()",
    meta: _91block_93JlOK0ZFVqbMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/block/[block].vue")
  },
  {
    name: "blocks",
    path: "/blocks",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/blocks.vue")
  },
  {
    name: "code-code",
    path: "/code/:code()",
    meta: _91code_93KfLFZx1VqcMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/code/[code].vue")
  },
  {
    name: "community-spend-pool",
    path: "/community-spend-pool",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/community-spend-pool.vue")
  },
  {
    name: _91contract_93QnARDyTDbDMeta?.name,
    path: "/contract/:contract()",
    meta: _91contract_93QnARDyTDbDMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract].vue"),
    children: [
  {
    name: action8p3hpi3kLTMeta?.name,
    path: "action",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/action.vue"),
    children: [
  {
    name: "contract-contract-action-execute",
    path: "execute",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/action/execute.vue")
  },
  {
    name: "contract-contract-action",
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/action/index.vue")
  }
]
  },
  {
    name: "contract-contract-balances",
    path: "balances",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/balances.vue")
  },
  {
    name: "contract-contract-cw20balances",
    path: "cw20balances",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/cw20balances.vue")
  },
  {
    name: "contract-contract",
    path: "",
    meta: indexKjlvZ6x6v1Meta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/index.vue")
  },
  {
    name: "contract-contract-init",
    path: "init",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/init.vue")
  },
  {
    name: "contract-contract-token-holders",
    path: "token-holders",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/contract/[contract]/token-holders.vue")
  }
]
  },
  {
    name: "env",
    path: "/env",
    meta: envXWlt2BHjPAMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/env.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/index.vue")
  },
  {
    name: "locales",
    path: "/locales",
    meta: localesY1cdtKHyrdMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/locales.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenance3AsTYwf8qYMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/maintenance.vue")
  },
  {
    name: "market-market",
    path: "/market/:market()",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/market/[market].vue")
  },
  {
    name: marketsfdWpEczQOtMeta?.name,
    path: "/markets",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/markets.vue"),
    children: [
  {
    name: "markets-funding-rate-history",
    path: "funding-rate-history",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/markets/funding-rate-history.vue")
  },
  {
    name: "markets",
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/markets/index.vue")
  },
  {
    name: "markets-realtime-funding-rate",
    path: "realtime-funding-rate",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/markets/realtime-funding-rate.vue")
  },
  {
    name: "markets-trading-rules",
    path: "trading-rules",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/markets/trading-rules.vue")
  }
]
  },
  {
    name: "nft-id",
    path: "/nft/:id()",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/nft/[id]/index.vue")
  },
  {
    name: "not-found",
    path: "/not-found",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/not-found.vue")
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundy9JZBBfKERMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/node_modules/.c12/github_InjectiveLabs_injective_1IfPyDVKuA/pages/playground.vue")
  },
  {
    name: "raw-tx",
    path: "/raw-tx",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/raw-tx.vue")
  },
  {
    name: smart_45contractsQ9KbCjESLFMeta?.name,
    path: "/smart-contracts",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/smart-contracts.vue"),
    children: [
  {
    name: "smart-contracts-code",
    path: "code",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/smart-contracts/code.vue")
  },
  {
    name: "smart-contracts",
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/smart-contracts/index.vue")
  }
]
  },
  {
    name: trade_45historyFE4qcg5gAvMeta?.name,
    path: "/trade-history",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history.vue"),
    children: [
  {
    name: "trade-history-derivatives-tradeId",
    path: "derivatives/:tradeId()",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/derivatives/[tradeId].vue")
  },
  {
    name: "trade-history-derivatives",
    path: "derivatives",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/derivatives/index.vue")
  },
  {
    name: "trade-history",
    path: "",
    meta: index87R2EnwfY6Meta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/index.vue")
  },
  {
    name: "trade-history-spot-tradeId",
    path: "spot/:tradeId()",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/spot/[tradeId].vue")
  },
  {
    name: "trade-history-spot",
    path: "spot",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/trade-history/spot/index.vue")
  }
]
  },
  {
    name: _91transaction_93Fudkvyr5NAMeta?.name,
    path: "/transaction/:transaction()",
    meta: _91transaction_93Fudkvyr5NAMeta || {},
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/transaction/[transaction].vue"),
    children: [
  {
    name: "transaction-transaction-event-logs",
    path: "event-logs",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/transaction/[transaction]/event-logs.vue")
  },
  {
    name: "transaction-transaction",
    path: "",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/transaction/[transaction]/index.vue")
  }
]
  },
  {
    name: "transactions",
    path: "/transactions",
    component: () => import("/home/runner/_work/injective-explorer/injective-explorer/pages/transactions.vue")
  }
]